import { motion } from 'framer-motion';

const SectionDivider = () => (
  <div className="flex items-center justify-center py-2">
    <motion.div
      initial={{ scaleX: 0 }}
      whileInView={{ scaleX: 1 }}
      viewport={{ once: true, margin: '-20px' }}
      transition={{ duration: 0.6, ease: [0.25, 0.1, 0.25, 1] }}
      className="w-12 h-px bg-foreground/10 origin-center"
    />
  </div>
);

export default SectionDivider;
